"use client";

import { memo } from "react";
import {
  useA2UIComponent,
  type A2UIComponentProps,
  type Types,
} from "@a2ui/react";

export const BeeOSAudioPlayer = memo(function BeeOSAudioPlayer({
  node,
  surfaceId,
}: A2UIComponentProps<Types.AudioPlayerNode>) {
  const { resolveString } = useA2UIComponent(node, surfaceId);
  const props = node.properties;
  const url = resolveString(props.url);
  const description = resolveString(props.description ?? null);

  if (!url) return null;

  const hostStyle: React.CSSProperties =
    node.weight !== undefined ? ({ "--weight": node.weight } as React.CSSProperties) : {};

  return (
    <div className="a2ui-audio" style={hostStyle}>
      <div className="flex flex-col gap-1.5">
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
        <audio src={url} controls className="w-full h-10" />
      </div>
    </div>
  );
});
